import React, {useEffect, useState} from 'react';
import {
    Paper, Table,
    TableBody, TableCell, TableContainer, TablePagination, TableRow, LinearProgress

} from '@material-ui/core';

import {coreStyle, EnhancedTableHead} from "../../../styles/config";
import {parseQueryParams} from "../../../utils/helpers";
import Resource from "../../../crud/resource";
import ReportSearch from "../../../widgets/ReportSearch";
import axios from "axios";
import Swal from "sweetalert2";
import {Link} from "react-router-dom";
import EmailContact from "../email";
import {useSelector} from "react-redux";
import Translate from "../../../utils/utils";

const headCells = [
    {id: 'grower', label: <Translate id="TABLE.GROWER"/>},
    {id: 'inspector', label: <Translate id="TABLE.INSPECTOR"/>},
    {id: 'shipment_date', label: <Translate id="TABLE.SHIPMENT_DATE"/>},
    {id: 'created_at', label: <Translate id="TABLE.DATE"/>},
    {id: 'emails_sent', label: <Translate id="TABLE.EMAILS_SENT"/>},
    {id: 'actions', label: <Translate id="TABLE.INSPECTOR"/>},
];

export default function GrowerFlowerOrders(props) {
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;
    const [inspections, setInspections] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const reportResource = new Resource('flowerGrowerReport');
    const [initialValues, setInitialValues] = useState({});
    const [name, setName] = React.useState(queryParams.name);
    const [date, setDate] = React.useState(queryParams.date);
    const [downloads, setDownloads] = useState([]);
    const user = useSelector(store => store.auth.user);
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: queryParams.perPage,
    });

    const download = (inspection) => {
        const time = new Date().getTime();
        const downloading = [...downloads];
        downloading.push(time);
        setDownloads([...downloading]);
        axios.get(`${process.env.REACT_APP_API_BASE_TEST}/report/flower/grower?inspectionId=${inspection.id}&download=true`, {
            responseType: 'arraybuffer',
        }).then(response => {

            const {data} = response;
            const url = URL.createObjectURL(new Blob([data], {
                type: "application/pdf"
            }));
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = url;
            a.download = `${inspection?.grower?.name}_${inspection.id}_${inspection.shipping_date}.pdf`
            a.click();
            window.URL.revokeObjectURL(url);
            setDownloads(downloading.filter(download_time => download_time !== time));

        }).catch(() => {
            setDownloads(downloading.filter(download_time => download_time !== time));
            Swal.fire({
                icon: 'error',
                text: 'Failed downloading report'
            });
        })
    }

    useEffect(() => {
        const list = () => {
            const resource = new Resource('flowerShipment/grower');
            setIsLoading(true);
            resource.index({
                perPage,
                page,
                name,
                date
            })
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setInspections(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            });
        };

        list();
    }, [page, perPage]);


    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`?page=${page}&perPage=${perPage}&name=${name}&date=${date}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&name=${name}&date=${date}`);
    };

    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}&date=${date}`);
    };

    const handleNameChange = (name) => setName(name);

    const handleDateChange = (date) => setDate(date);

    const openModal = (inspection) => {
        const to = [];
        to.push(inspection?.grower?.email || '');
        to.push(inspection?.inspector?.email || '');
        to.push(inspection?.grower?.secondary_email || '');
        setInitialValues({
            inspection_id: inspection.id,
            inspector: `${inspection?.inspector?.first_name} ${inspection?.inspector?.last_name}`,
            created_at: inspection.shipping_date,
            account_id: inspection?.grower?.id,
            account_name: inspection?.grower?.name,
            language_id: user.language_id,
            to: to.filter((email) => email !== null && email.indexOf('@') > 0),
            cc: [],
            type: <Translate id="TABLE.GROWER"/>
        });

    };

    return (
        <div className={coreStyle.root}>
            <div className="add-user__button">
            </div>
            <ReportSearch handleNameChange={handleNameChange} handleDateChange={handleDateChange} onSubmit={onSearch}
                          module={"Grower"} onClear={onClearSearch}
                          disabled={isLoading} value={queryParams.name} dateTerm={queryParams.date}/>

            {(isLoading || downloads.length > 0) && <LinearProgress color="secondary"/>}
            <Paper className={coreStyle.paper}>
                <EmailContact onCloseModal={() => setInitialValues({})} initialValues={initialValues}
                              resource={reportResource}/>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            rowCount={isLoading ? 0 : inspections.length}
                            headCells={headCells}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {inspections.map(inspection => {

                                inspection.getStatus = () => {
                                    return inspection.active === '1' ? 'active' : 'inactive';
                                };

                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={inspection.id}
                                    >
                                        <TableCell>{inspection?.grower?.name}</TableCell>
                                        <TableCell>{inspection?.inspector?.full_name}</TableCell>
                                        <TableCell>{inspection.shipping_date}</TableCell>
                                        <TableCell>{inspection.created_at}</TableCell>
                                        <TableCell>{inspection?.emails_sent}</TableCell>
                                        <TableCell>
                                            <Link
                                                to={`/reports/flowers/grower/view?inspectionId=${inspection.id}&grower=${window.btoa(inspection?.grower?.name)}&shipping_date=${inspection.shipping_date}`}>
                                                <button className='button-edit-delete'>
                                                    <Translate id="TABLE.ACTIONS.VIEW"/>
                                                </button>
                                            </Link>
                                            <em className='actions-separator'>|</em>
                                            <Link to="#">
                                                <button className='button-edit-delete'
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            download(inspection);
                                                        }}>
                                                    <Translate id="TABLE.ACTIONS.DOWNLOAD"/>
                                                </button>
                                            </Link>
                                            {inspection.grower && inspection.grower.email && inspection.grower.email.length &&
                                                <>
                                                    <em className='actions-separator'>|</em>
                                                    <button className='button-edit-delete'
                                                            onClick={() => openModal(inspection)}>
                                                        <Translate id="TABLE.ACTIONS.EMAIL"/>
                                                    </button>
                                                </>
                                            }
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]} labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
